/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ActionInputs */

const en_action = /** @type {(inputs: ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const es_action = /** @type {(inputs: ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const fr_action = /** @type {(inputs: ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_action = /** @type {(inputs: ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

const id_action = /** @type {(inputs: ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan`)
};

/** @type {(inputs: ActionInputs) => LocalizedString} */
const ja_action = en_action;

/** @type {(inputs: ActionInputs) => LocalizedString} */
const zh_action = en_action;

/** @type {(inputs: ActionInputs) => LocalizedString} */
const ar_action = en_action;

/** @type {(inputs: ActionInputs) => LocalizedString} */
const it_action = en_action;

/** @type {(inputs: ActionInputs) => LocalizedString} */
const ru_action = en_action;

/** @type {(inputs: ActionInputs) => LocalizedString} */
const pt_action = en_action;

/** @type {(inputs: ActionInputs) => LocalizedString} */
const ko_action = en_action;

/**
* | output |
* | --- |
* | "Action" |
*
* @param {ActionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action = /** @type {((inputs?: ActionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action(inputs)
	if (locale === "es") return es_action(inputs)
	if (locale === "fr") return fr_action(inputs)
	if (locale === "de") return de_action(inputs)
	if (locale === "ja") return ja_action(inputs)
	if (locale === "zh") return zh_action(inputs)
	if (locale === "ar") return ar_action(inputs)
	if (locale === "id") return id_action(inputs)
	if (locale === "it") return it_action(inputs)
	if (locale === "ru") return ru_action(inputs)
	if (locale === "pt") return pt_action(inputs)
	return ko_action(inputs)
});